import { RefObject, useEffect, useState } from "react";

import { useResize } from "../../../hooks/useResize";

export const useContainerWidth = (ref: RefObject<HTMLDivElement>): number => {
  const [containerWidth, setContainerWidth] = useState<number>();

  useResize(() => setContainerWidth(ref.current?.getBoundingClientRect().width));

  useEffect(() => {
    if (ref.current && containerWidth === undefined) {
      setContainerWidth(ref.current?.getBoundingClientRect().width);
    }
  }, []); // eslint-disable-line

  return containerWidth;
};
